import React from "react";
import { format } from "date-fns";
export const getCurrentFormattedDate = () =>
  `${format(new Date(), "yyyy-MM-dd")}T${format(new Date(), "HH:mm:ss.SSS")}Z`;
